// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OutputRecords_wrapper__2NIuE"};